import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApisService } from 'app/services/apis.service';
import { environment } from 'environments/environment.staging';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-notifications',
  templateUrl: './send-notifications.component.html',
  styleUrls: ['./send-notifications.component.scss']
})
export class SendNotificationsComponent implements OnInit {
 entityForm: FormGroup;
  imagePreview: string | null = null;
  userId : any 
  userInfo : any
  constructor(private fb: FormBuilder,
    private apisService: ApisService, 
    private toastr :ToastrService, 
    private activataedRoute : ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.activataedRoute.params.subscribe((params) => {
      this.userId = params['id'];
      console.log(this.userId);
    })
    this.userData();
    this.setForm();
  }
addNotification(data:any){ 
  this.apisService.sendNotification(data).subscribe({
    next: (data) => {
      console.log("Successfully added ", data );
      this.toastr.success("Notiication is successfully added")
      this.entityForm.reset()
    },
    error: (error) => {
      console.log("error ", error);
      this.toastr.error("Error in adding notification, Please Try again")
    },
  })
}


/*----------  Setting Form  ----------*/
setForm() {
  this.entityForm = this.fb.group({
    title : this.fb.group({ 
      en : ['', [Validators.required, Validators.minLength(3)]],
      ar: ['', [Validators.required, Validators.minLength(3)]],
    }),
    users : this.fb.array([
      this.fb.control(Number(this.userId))
    ]),
    body : this.fb.group({ 
      en : ['', [Validators.required, Validators.minLength(3)]],
      ar : ['', [Validators.required, Validators.minLength(3)]],
    })
  });
}


/*----------  get User data  ----------*/
userData(){ 
  this.apisService.getUserProfile(this.userId).subscribe({
    next: (response) => {
      console.log("Successfully added ", response );
      this.userInfo = response.data
    },
    error: (error) => {
      console.log("error ", error);
    },
  })
}



// submitting the form
  onSubmit() {
    if (this.entityForm.valid) {
      console.log('Form Data:', this.entityForm.value);
      console.log('Form Submitted Successfully');
      this.addNotification(this.entityForm.value);
    } else {
      console.log(this.entityForm.value);
      console.log('Please fill all required fields');
    }
  }

  
  /*----------  get user image  ----------*/
    getFirstImage(postItem): string {
      return postItem?.media
        ? environment.mediaUrl + "/" + postItem.media.url
        : // : "assets/images/logo/logo1.svg";
          "assets/images/goalngo/profile.svg";
    }
  
  




}

